(function () {
  // Clave nueva (varias listas) y clave antigua (array plano) que se migra una vez
  var STORAGE_KEY = 'sifrah-wishlists';
  var LEGACY_KEY = 'sifrah-wishlist';
  var DEFAULT_ID = 'default';
  var DEFAULT_NAME = 'Mis favoritos';
  var NAME_MAX = 40;

  var CLOSE_ICON =
    '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true"><path d="M1 1L9 9M9 1L1 9" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>';

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function storageGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
      return true;
    } catch (error) {
      return false;
    }
  }

  // Normaliza un producto al formato guardado
  function normalizeItem(product) {
    return {
      id: String(product.id),
      handle: product.handle || '',
      title: product.title || '',
      url: product.url || '',
      image: product.image || '',
      price: product.price || '',
      variantId: product.variantId ? String(product.variantId) : '',
    };
  }

  function cleanItems(items) {
    var seen = {};
    return (Array.isArray(items) ? items : []).filter(function (item) {
      if (!item || !item.id || seen[String(item.id)]) return false;
      seen[String(item.id)] = true;
      return true;
    }).map(normalizeItem);
  }

  // Garantiza que la lista por defecto exista, vaya primero y se llame «Mis favoritos»
  function normalizeState(state) {
    var lists = state && Array.isArray(state.lists) ? state.lists : [];
    var seen = {};
    var clean = [];
    var defaultList = null;

    lists.forEach(function (list) {
      if (!list || !list.id || seen[String(list.id)]) return;
      seen[String(list.id)] = true;
      var entry = {
        id: String(list.id),
        name: String(list.name || '').slice(0, NAME_MAX) || 'Lista',
        items: cleanItems(list.items),
      };
      if (entry.id === DEFAULT_ID) {
        entry.name = DEFAULT_NAME;
        defaultList = entry;
      } else {
        clean.push(entry);
      }
    });

    clean.unshift(defaultList || { id: DEFAULT_ID, name: DEFAULT_NAME, items: [] });

    var active = state && state.active ? String(state.active) : DEFAULT_ID;
    if (!seen[active]) active = DEFAULT_ID;

    return { lists: clean, active: active };
  }

  // Migración: el array antiguo pasa a ser «Mis favoritos». La clave antigua se conserva
  // (ya no se lee) para no perder nada si hubiera que volver al tema anterior.
  function migrateLegacy() {
    var legacy = [];
    try {
      var raw = storageGet(LEGACY_KEY);
      legacy = raw ? JSON.parse(raw) : [];
    } catch (error) {
      legacy = [];
    }

    var state = normalizeState({
      lists: [{ id: DEFAULT_ID, name: DEFAULT_NAME, items: Array.isArray(legacy) ? legacy : [] }],
      active: DEFAULT_ID,
    });

    storageSet(STORAGE_KEY, JSON.stringify(state));
    return state;
  }

  function readState() {
    var raw = storageGet(STORAGE_KEY);
    if (!raw) return migrateLegacy();

    try {
      return normalizeState(JSON.parse(raw));
    } catch (error) {
      // Dato corrupto: intentamos rescatar la lista antigua
      return migrateLegacy();
    }
  }

  // Todos los productos de todas las listas, sin duplicados
  function allItems(state) {
    var seen = {};
    var items = [];
    state.lists.forEach(function (list) {
      list.items.forEach(function (item) {
        if (seen[item.id]) return;
        seen[item.id] = true;
        items.push(item);
      });
    });
    return items;
  }

  function findList(state, listId) {
    var id = String(listId);
    for (var i = 0; i < state.lists.length; i++) {
      if (state.lists[i].id === id) return state.lists[i];
    }
    return null;
  }

  function writeState(state) {
    var clean = normalizeState(state);
    storageSet(STORAGE_KEY, JSON.stringify(clean));
    document.dispatchEvent(
      new CustomEvent('theme:wishlist:updated', {
        detail: { items: allItems(clean), lists: clean.lists, active: clean.active },
        bubbles: true,
      })
    );
    return clean;
  }

  function plural(n, one, many) {
    return n + ' ' + (n === 1 ? one : many);
  }

  function newListId() {
    return 'l' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
  }

  // Devuelve un mensaje de error o '' si el nombre es válido
  function validateName(state, name, exceptId) {
    var value = String(name || '').trim();
    if (!value) return 'Escribe un nombre para la lista.';
    if (value.length > NAME_MAX) return 'Usa como máximo ' + NAME_MAX + ' caracteres.';
    var lower = value.toLowerCase();
    var taken = state.lists.some(function (list) {
      return list.id !== exceptId && list.name.toLowerCase() === lower;
    });
    return taken ? 'Ya tienes una lista con ese nombre.' : '';
  }

  window.SifrahWishlist = {
    // API compatible con la versión anterior
    get: function () {
      return allItems(readState());
    },
    has: function (productId) {
      var id = String(productId);
      return allItems(readState()).some(function (item) {
        return item.id === id;
      });
    },
    add: function (product, listId) {
      if (!product || !product.id) return window.SifrahWishlist.get();

      var state = readState();
      var list = findList(state, listId || state.active) || state.lists[0];
      var id = String(product.id);
      var exists = list.items.some(function (item) {
        return item.id === id;
      });

      if (!exists) {
        list.items.unshift(normalizeItem(product));
        state = writeState(state);
      }

      return allItems(state);
    },
    // Sin listId quita el producto de todas las listas (comportamiento del corazón)
    remove: function (productId, listId) {
      var id = String(productId);
      var state = readState();
      state.lists.forEach(function (list) {
        if (listId && list.id !== String(listId)) return;
        list.items = list.items.filter(function (item) {
          return item.id !== id;
        });
      });
      return allItems(writeState(state));
    },

    // API de listas
    getState: readState,
    getLists: function () {
      return readState().lists;
    },
    setActive: function (listId) {
      var state = readState();
      if (!findList(state, listId)) return state;
      state.active = String(listId);
      return writeState(state);
    },
    validateName: function (name, exceptId) {
      return validateName(readState(), name, exceptId);
    },
    createList: function (name) {
      var state = readState();
      if (validateName(state, name)) return null;
      var list = { id: newListId(), name: String(name).trim(), items: [] };
      state.lists.push(list);
      state.active = list.id;
      writeState(state);
      return list;
    },
    renameList: function (listId, name) {
      var state = readState();
      var list = findList(state, listId);
      if (!list || list.id === DEFAULT_ID || validateName(state, name, list.id)) return false;
      list.name = String(name).trim();
      writeState(state);
      return true;
    },
    deleteList: function (listId) {
      if (String(listId) === DEFAULT_ID) return false;
      var state = readState();
      state.lists = state.lists.filter(function (list) {
        return list.id !== String(listId);
      });
      if (state.active === String(listId)) state.active = DEFAULT_ID;
      writeState(state);
      return true;
    },
  };

  /* ---------- Carrito ---------- */

  function shopRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return root || '/';
  }

  // POST /cart/add.js con varios items; rechaza con un mensaje en español
  function addToCart(items) {
    return fetch(shopRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    }).then(function (response) {
      return response
        .json()
        .catch(function () {
          return {};
        })
        .then(function (data) {
          if (!response.ok || data.status) {
            var message = (data && (data.description || data.message)) || '';
            throw new Error(
              typeof message === 'string' && message ? message : 'No pudimos agregarlo al carrito. Inténtalo otra vez.'
            );
          }
          return data;
        });
    });
  }

  // Refresca el minicarrito del tema y el contador de la cabecera
  // Tras getCart() el tema dispara theme:product:added y abre el minicarrito encima de la
  // wishlist; al agregar un solo producto se corta ese evento una vez (captura en window).
  function suppressNextProductAdded() {
    var timeout;
    function release() {
      window.removeEventListener('theme:product:added', stop, true);
      clearTimeout(timeout);
    }
    function stop(event) {
      event.stopImmediatePropagation();
      release();
    }
    window.addEventListener('theme:product:added', stop, true);
    timeout = setTimeout(release, 5000);
  }

  function refreshCart(keepCartClosed) {
    var cartItems = document.querySelector('cart-items');
    if (cartItems && typeof cartItems.getCart === 'function') {
      if (keepCartClosed) suppressNextProductAdded();
      cartItems.getCart();
    }

    return fetch(shopRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        document.dispatchEvent(
          new CustomEvent('theme:cart:change', {
            bubbles: true,
            detail: { cartCount: cart.item_count },
          })
        );
        return cart;
      })
      .catch(function () {
        return null;
      });
  }

  function openThemeCart() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.openCartDrawer === 'function') {
      cartDrawer.openCartDrawer();
    } else if (cartDrawer) {
      document.dispatchEvent(new CustomEvent('theme:cart:toggle', { bubbles: true }));
    } else {
      // Tema sin minicarrito: vamos a la página del carrito
      window.location.href = shopRoot() + 'cart';
    }
  }

  /* ---------- Corazones de las tarjetas ---------- */

  function syncWishlistButtons(items) {
    var ids = {};
    (items || []).forEach(function (item) {
      ids[String(item.id)] = true;
    });

    document.querySelectorAll('[data-wishlist-add]').forEach(function (button) {
      var isActive = Boolean(ids[String(button.getAttribute('data-product-id'))]);
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function productFromButton(button) {
    return {
      id: button.getAttribute('data-product-id'),
      handle: button.getAttribute('data-product-handle'),
      title: button.getAttribute('data-product-title'),
      url: button.getAttribute('data-product-url'),
      image: button.getAttribute('data-product-image'),
      price: button.getAttribute('data-product-price'),
      variantId: button.getAttribute('data-variant-id'),
    };
  }

  function openWishlistDrawer() {
    var drawer = document.querySelector('wishlist-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    } else {
      document.dispatchEvent(new CustomEvent('theme:wishlist-drawer:open', { bubbles: true }));
    }
  }

  // Guarda en una lista concreta, la deja activa y abre el drawer
  function saveToList(product, listId) {
    window.SifrahWishlist.add(product, listId);
    window.SifrahWishlist.setActive(listId);
    openWishlistDrawer();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-wishlist-add]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    var product = productFromButton(button);
    if (!product.id) return;

    if (window.SifrahWishlist.has(product.id)) {
      window.SifrahWishlist.remove(product.id);
      return;
    }

    var lists = window.SifrahWishlist.getLists();
    if (lists.length <= 1) {
      saveToList(product, lists[0] ? lists[0].id : DEFAULT_ID);
      return;
    }

    // Dos o más listas: preguntamos dónde guardarlo
    var picker = document.querySelector('[data-wishlist-picker]');
    if (picker && picker.wishlistPicker) {
      picker.wishlistPicker.open(product, button);
    } else {
      saveToList(product, window.SifrahWishlist.getState().active);
    }
  });

  document.addEventListener('theme:wishlist:updated', function (event) {
    syncWishlistButtons(event.detail && event.detail.items ? event.detail.items : window.SifrahWishlist.get());
  });

  document.addEventListener('DOMContentLoaded', function () {
    syncWishlistButtons(window.SifrahWishlist.get());
  });

  /* ---------- Hoja «¿Dónde lo guardo?» ---------- */

  function WishlistPicker(root) {
    this.root = root;
    this.form = root.querySelector('[data-wishlist-picker-form]');
    this.options = root.querySelector('[data-wishlist-picker-options]');
    this.newWrap = root.querySelector('[data-wishlist-picker-new]');
    this.input = root.querySelector('[data-wishlist-picker-input]');
    this.error = root.querySelector('[data-wishlist-picker-error]');
    this.product = null;
    this.returnFocus = null;
    this.lockedScroll = false;

    var self = this;

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-wishlist-picker-close]')) {
        event.preventDefault();
        self.close();
      }
    });

    root.addEventListener('change', function (event) {
      if (event.target.name === 'wishlist-picker-list') self.syncNewField();
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        event.preventDefault();
        self.close();
      } else if (event.key === 'Tab') {
        self.trapFocus(event);
      }
    });

    if (this.form) {
      this.form.addEventListener('submit', function (event) {
        event.preventDefault();
        self.save();
      });
    }

    root.wishlistPicker = this;
  }

  WishlistPicker.prototype.open = function (product, trigger) {
    var state = window.SifrahWishlist.getState();
    this.product = product;
    this.returnFocus = trigger || document.activeElement;

    this.options.innerHTML =
      state.lists
        .map(function (list) {
          return (
            '<label class="wishlist-picker__option">' +
            '<input type="radio" name="wishlist-picker-list" value="' +
            escapeHtml(list.id) +
            '"' +
            (list.id === state.active ? ' checked' : '') +
            '>' +
            '<span class="wishlist-picker__option-name">' +
            escapeHtml(list.name) +
            '</span>' +
            '<span class="wishlist-picker__option-count">' +
            list.items.length +
            '</span>' +
            '</label>'
          );
        })
        .join('') +
      '<label class="wishlist-picker__option wishlist-picker__option--new">' +
      '<input type="radio" name="wishlist-picker-list" value="__new">' +
      '<span class="wishlist-picker__option-name">Crear lista nueva</span>' +
      '</label>';

    this.input.value = '';
    this.setError('');
    this.syncNewField();

    this.root.hidden = false;
    this.root.classList.add('is-open');

    var drawer = document.querySelector('wishlist-drawer');
    if (!(drawer && drawer.isOpen)) {
      document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true }));
      this.lockedScroll = true;
    }

    var checked = this.options.querySelector('input:checked') || this.options.querySelector('input');
    if (checked) checked.focus();
  };

  WishlistPicker.prototype.close = function (keepFocus) {
    if (this.root.hidden) return;
    this.root.hidden = true;
    this.root.classList.remove('is-open');
    this.product = null;

    if (this.lockedScroll) {
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
      this.lockedScroll = false;
    }

    if (!keepFocus && this.returnFocus && typeof this.returnFocus.focus === 'function') {
      this.returnFocus.focus();
    }
    this.returnFocus = null;
  };

  WishlistPicker.prototype.selected = function () {
    var checked = this.options.querySelector('input:checked');
    return checked ? checked.value : '';
  };

  WishlistPicker.prototype.syncNewField = function () {
    var isNew = this.selected() === '__new';
    this.newWrap.hidden = !isNew;
    this.input.required = isNew;
    if (isNew) this.input.focus();
    this.setError('');
  };

  WishlistPicker.prototype.setError = function (message) {
    this.error.textContent = message;
    this.error.hidden = !message;
  };

  WishlistPicker.prototype.save = function () {
    var product = this.product;
    var choice = this.selected();
    if (!product) return this.close();

    if (!choice) {
      this.setError('Elige una lista.');
      return;
    }

    var listId = choice;
    if (choice === '__new') {
      var message = window.SifrahWishlist.validateName(this.input.value);
      if (message) {
        this.setError(message);
        this.input.focus();
        return;
      }
      var list = window.SifrahWishlist.createList(this.input.value);
      if (!list) return;
      listId = list.id;
    }

    this.close(true);
    saveToList(product, listId);
  };

  WishlistPicker.prototype.trapFocus = function (event) {
    var focusables = Array.prototype.filter.call(
      this.root.querySelectorAll('button, input, [tabindex]:not([tabindex="-1"])'),
      function (el) {
        return !el.disabled && el.offsetParent !== null;
      }
    );
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  function initPicker() {
    var root = document.querySelector('[data-wishlist-picker]');
    if (root && !root.wishlistPicker) new WishlistPicker(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPicker);
  } else {
    initPicker();
  }
  document.addEventListener('shopify:section:load', initPicker);

  /* ---------- Drawer ---------- */

  if (customElements.get('wishlist-drawer')) return;

  class WishlistDrawer extends HTMLElement {
    constructor() {
      super();
      this.isOpen = false;
      this.mode = null; // null | 'create' | 'rename' | 'delete'
      this.onBodyClick = this.onBodyClick.bind(this);
      this.onToggleClick = this.onToggleClick.bind(this);
      this.onKeyUp = this.onKeyUp.bind(this);
      this.onWishlistUpdated = this.onWishlistUpdated.bind(this);
      this.onInnerClick = this.onInnerClick.bind(this);
      this.onInnerSubmit = this.onInnerSubmit.bind(this);
    }

    connectedCallback() {
      this.inner = this.querySelector('[data-wishlist-drawer-inner]');
      this.body = this.querySelector('[data-wishlist-body]');
      this.empty = this.querySelector('[data-wishlist-empty]');
      this.list = this.querySelector('[data-wishlist-list]');
      this.count = this.querySelector('[data-wishlist-count]');
      this.tabs = this.querySelector('[data-wishlist-tabs]');
      this.manage = this.querySelector('[data-wishlist-manage]');
      this.footer = this.querySelector('[data-wishlist-footer]');
      this.buyAllButton = this.querySelector('[data-wishlist-buy-all]');
      this.status = this.querySelector('[data-wishlist-status]');
      this.closeButtons = this.querySelectorAll('[data-wishlist-drawer-close]');

      this.closeButtons.forEach((btn) => {
        btn.addEventListener('click', (event) => {
          event.preventDefault();
          this.close();
        });
      });

      if (this.inner) {
        this.inner.addEventListener('click', this.onInnerClick);
        this.inner.addEventListener('submit', this.onInnerSubmit);
      }

      this.addEventListener('keyup', this.onKeyUp);
      document.addEventListener('click', this.onToggleClick);
      document.addEventListener('theme:wishlist-drawer:toggle', this.toggle.bind(this));
      document.addEventListener('theme:wishlist-drawer:open', this.open.bind(this));
      document.addEventListener('theme:wishlist-drawer:close', this.close.bind(this));
      document.addEventListener('theme:wishlist:updated', this.onWishlistUpdated);

      this.render();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onToggleClick);
      document.removeEventListener('theme:wishlist:updated', this.onWishlistUpdated);
      document.body.removeEventListener('click', this.onBodyClick);
    }

    onWishlistUpdated() {
      this.render();
    }

    onInnerClick(event) {
      var target = event.target;
      var el;

      if ((el = target.closest('[data-wishlist-tab]'))) {
        event.preventDefault();
        this.mode = null;
        this.setStatus('');
        var tabId = el.getAttribute('data-wishlist-tab');
        window.SifrahWishlist.setActive(tabId);
        this.focusSelector('[data-wishlist-tab="' + tabId + '"]');
      } else if ((el = target.closest('[data-wishlist-new]'))) {
        event.preventDefault();
        this.setMode('create');
      } else if ((el = target.closest('[data-wishlist-rename]'))) {
        event.preventDefault();
        this.setMode('rename');
      } else if ((el = target.closest('[data-wishlist-delete]'))) {
        event.preventDefault();
        this.setMode('delete');
      } else if ((el = target.closest('[data-wishlist-delete-confirm]'))) {
        event.preventDefault();
        var state = window.SifrahWishlist.getState();
        this.mode = null;
        window.SifrahWishlist.deleteList(state.active);
        this.setStatus('Eliminaste la lista.');
        this.focusSelector('[data-wishlist-tab="' + DEFAULT_ID + '"]');
      } else if ((el = target.closest('[data-wishlist-cancel]'))) {
        event.preventDefault();
        this.setMode(null);
      } else if ((el = target.closest('[data-wishlist-remove]'))) {
        event.preventDefault();
        var activeId = window.SifrahWishlist.getState().active;
        window.SifrahWishlist.remove(el.getAttribute('data-product-id'), activeId);
        this.focusSelector('[data-wishlist-tab="' + activeId + '"]');
      } else if ((el = target.closest('[data-wishlist-cart]'))) {
        event.preventDefault();
        this.addItemToCart(el);
      } else if ((el = target.closest('[data-wishlist-buy-all]'))) {
        event.preventDefault();
        this.buyAll();
      } else if ((el = target.closest('[data-wishlist-open-cart]'))) {
        event.preventDefault();
        this.close();
        openThemeCart();
      }
    }

    onInnerSubmit(event) {
      var form = event.target.closest('[data-wishlist-name-form]');
      if (!form) return;
      event.preventDefault();

      var input = form.querySelector('input');
      var value = input ? input.value : '';
      var state = window.SifrahWishlist.getState();
      var isRename = this.mode === 'rename';
      var message = window.SifrahWishlist.validateName(value, isRename ? state.active : null);

      if (message) {
        this.setManageError(message);
        if (input) input.focus();
        return;
      }

      this.mode = null;
      if (isRename) {
        window.SifrahWishlist.renameList(state.active, value);
        this.setStatus('Cambiaste el nombre de la lista.');
        this.focusSelector('[data-wishlist-tab="' + state.active + '"]');
      } else {
        var list = window.SifrahWishlist.createList(value);
        this.setStatus('Creaste la lista «' + (list ? list.name : '') + '».');
        if (list) this.focusSelector('[data-wishlist-tab="' + list.id + '"]');
      }
    }

    onToggleClick(event) {
      if (event.target.closest('[data-wishlist-add]')) return;

      var toggle = event.target.closest('[data-wishlist-toggle]');
      if (!toggle) return;

      event.preventDefault();
      this.toggle();
    }

    onKeyUp(event) {
      if (event.code !== 'Escape' && event.key !== 'Escape') return;
      // Con un formulario abierto, Escape solo lo cancela
      if (this.mode) {
        this.setMode(null);
        return;
      }
      this.close();
    }

    onBodyClick(event) {
      if (event.target.hasAttribute('data-drawer-underlay')) {
        this.close();
      }
    }

    focusSelector(selector) {
      var el = this.querySelector(selector);
      if (el && typeof el.focus === 'function') el.focus({ preventScroll: true });
    }

    setMode(mode) {
      this.mode = mode;
      this.renderManage(window.SifrahWishlist.getState());
      if (mode === 'create' || mode === 'rename') {
        this.focusSelector('[data-wishlist-name-form] input');
      } else if (mode === 'delete') {
        this.focusSelector('[data-wishlist-cancel]');
      } else {
        this.focusSelector('[data-wishlist-tab="' + window.SifrahWishlist.getState().active + '"]');
      }
    }

    setManageError(message) {
      var error = this.querySelector('[data-wishlist-manage-error]');
      if (!error) return;
      error.textContent = message;
      error.hidden = !message;
    }

    setStatus(message, html) {
      if (!this.status) return;
      if (html) {
        this.status.innerHTML = html;
      } else {
        this.status.textContent = message || '';
      }
      this.status.hidden = !(message || html);
      this.updateFooter();
    }

    // El pie se oculta si no hay nada que comprar ni mensaje que mostrar
    updateFooter() {
      if (!this.footer) return;
      var state = window.SifrahWishlist.getState();
      var active = findList(state, state.active) || state.lists[0];
      var hasItems = active.items.length > 0;
      if (this.buyAllButton) this.buyAllButton.hidden = !hasItems;
      this.footer.hidden = !hasItems && (!this.status || this.status.hidden);
    }

    render() {
      var state = window.SifrahWishlist.getState();
      var total = allItems(state).length;
      var active = findList(state, state.active) || state.lists[0];

      if (this.count) {
        this.count.hidden = total === 0;
        this.count.textContent = '(' + total + ')';
      }

      this.renderTabs(state);
      this.renderManage(state);
      this.renderItems(active);

      this.updateFooter();
    }

    renderTabs(state) {
      if (!this.tabs) return;
      this.tabs.innerHTML =
        state.lists
          .map(function (list) {
            var isActive = list.id === state.active;
            return (
              '<button type="button" class="wishlist-tab' +
              (isActive ? ' is-active' : '') +
              '" data-wishlist-tab="' +
              escapeHtml(list.id) +
              '" aria-pressed="' +
              (isActive ? 'true' : 'false') +
              '">' +
              '<span class="wishlist-tab__name">' +
              escapeHtml(list.name) +
              '</span>' +
              '<span class="wishlist-tab__count" aria-label="' +
              list.items.length +
              (list.items.length === 1 ? ' producto' : ' productos') +
              '">' +
              list.items.length +
              '</span>' +
              '</button>'
            );
          })
          .join('') +
        '<button type="button" class="wishlist-tab wishlist-tab--new" data-wishlist-new>+ Nueva lista</button>';
    }

    renderManage(state) {
      if (!this.manage) return;
      var active = findList(state, state.active) || state.lists[0];
      var isDefault = active.id === DEFAULT_ID;
      var html = '';
      var inputId = 'WishlistName-' + (this.id || 'drawer');

      if (this.mode === 'create' || (this.mode === 'rename' && !isDefault)) {
        var isRename = this.mode === 'rename';
        html =
          '<form class="wishlist-manage__form" data-wishlist-name-form novalidate>' +
          '<label class="wishlist-manage__label" for="' +
          inputId +
          '">' +
          (isRename ? 'Nuevo nombre de la lista' : 'Nombre de la nueva lista') +
          '</label>' +
          '<input class="wishlist-input" id="' +
          inputId +
          '" type="text" maxlength="' +
          NAME_MAX +
          '" autocomplete="off" enterkeyhint="done" value="' +
          (isRename ? escapeHtml(active.name) : '') +
          '" placeholder="Ej.: Regalos, Para la boda">' +
          '<p class="wishlist-manage__error" data-wishlist-manage-error role="alert" hidden></p>' +
          '<div class="wishlist-manage__actions">' +
          '<button type="submit" class="wishlist-btn wishlist-btn--primary">' +
          (isRename ? 'Guardar' : 'Crear lista') +
          '</button>' +
          '<button type="button" class="wishlist-btn wishlist-btn--ghost" data-wishlist-cancel>Cancelar</button>' +
          '</div>' +
          '</form>';
      } else if (this.mode === 'delete' && !isDefault) {
        var n = active.items.length;
        html =
          '<div class="wishlist-manage__confirm" role="alertdialog" aria-label="Confirmar eliminación">' +
          '<p>¿Eliminar la lista «' +
          escapeHtml(active.name) +
          '»?' +
          (n ? ' Se quitarán sus ' + n + (n === 1 ? ' producto' : ' productos') + ' de esta lista.' : '') +
          '</p>' +
          '<div class="wishlist-manage__actions">' +
          '<button type="button" class="wishlist-btn wishlist-btn--danger" data-wishlist-delete-confirm>Sí, eliminar</button>' +
          '<button type="button" class="wishlist-btn wishlist-btn--ghost" data-wishlist-cancel>Cancelar</button>' +
          '</div>' +
          '</div>';
      } else {
        this.mode = null;
        if (!isDefault) {
          html =
            '<div class="wishlist-manage__links">' +
            '<button type="button" class="wishlist-link" data-wishlist-rename>Renombrar</button>' +
            '<button type="button" class="wishlist-link" data-wishlist-delete>Eliminar lista</button>' +
            '</div>';
        }
      }

      this.manage.innerHTML = html;
      this.manage.hidden = !html;
    }

    renderItems(active) {
      if (!this.list || !this.empty) return;
      var items = active.items;

      if (items.length === 0) {
        this.empty.hidden = false;
        this.list.hidden = true;
        this.list.innerHTML = '';
        return;
      }

      this.empty.hidden = true;
      this.list.hidden = false;
      this.list.innerHTML = items
        .map(function (item) {
          var imageHtml = item.image
            ? '<img class="wishlist-drawer__item-image" src="' +
              escapeHtml(item.image) +
              '" alt="' +
              escapeHtml(item.title) +
              '" loading="lazy" width="72" height="72">'
            : '<span class="wishlist-drawer__item-image wishlist-drawer__item-image--empty"></span>';

          return (
            '<li class="wishlist-drawer__item" data-wishlist-item="' +
            escapeHtml(item.id) +
            '">' +
            '<a class="wishlist-drawer__item-media" href="' +
            escapeHtml(item.url) +
            '" tabindex="-1" aria-hidden="true">' +
            imageHtml +
            '</a>' +
            '<div class="wishlist-drawer__item-info">' +
            '<a class="wishlist-drawer__item-title" href="' +
            escapeHtml(item.url) +
            '">' +
            escapeHtml(item.title) +
            '</a>' +
            '<span class="wishlist-drawer__item-price">' +
            escapeHtml(item.price) +
            '</span>' +
            '<button type="button" class="wishlist-btn wishlist-btn--primary wishlist-drawer__item-cart" data-wishlist-cart data-variant-id="' +
            escapeHtml(item.variantId) +
            '" data-product-title="' +
            escapeHtml(item.title) +
            '">Agregar al carrito</button>' +
            '<p class="wishlist-drawer__item-message" data-wishlist-item-message role="status" hidden></p>' +
            '</div>' +
            '<button type="button" class="wishlist-drawer__item-remove" data-wishlist-remove data-product-id="' +
            escapeHtml(item.id) +
            '" aria-label="Quitar ' +
            escapeHtml(item.title) +
            ' de esta lista">' +
            CLOSE_ICON +
            '</button>' +
            '</li>'
          );
        })
        .join('');
    }

    // Botón «Agregar al carrito» de cada producto
    addItemToCart(button) {
      if (button.getAttribute('aria-busy') === 'true') return;

      var item = button.closest('[data-wishlist-item]');
      var message = item ? item.querySelector('[data-wishlist-item-message]') : null;
      var variantId = parseInt(button.getAttribute('data-variant-id'), 10);
      var label = 'Agregar al carrito';

      function showMessage(text) {
        if (!message) return;
        message.textContent = text;
        message.hidden = !text;
      }

      showMessage('');

      if (!variantId) {
        showMessage('Este producto no está disponible para agregar. Entra a su ficha para elegirlo.');
        return;
      }

      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      button.classList.add('is-loading');
      button.textContent = 'Agregando…';

      addToCart([{ id: variantId, quantity: 1 }])
        .then(function () {
          button.classList.remove('is-loading');
          button.classList.add('is-added');
          button.textContent = 'Agregado';
          return refreshCart(true);
        })
        .catch(function (error) {
          button.classList.remove('is-loading');
          button.textContent = label;
          showMessage(error && error.message ? error.message : 'No pudimos agregarlo al carrito. Inténtalo otra vez.');
        })
        .then(function () {
          button.removeAttribute('aria-busy');
          button.disabled = false;
          window.setTimeout(function () {
            if (button.classList.contains('is-added')) {
              button.classList.remove('is-added');
              button.textContent = label;
            }
          }, 2500);
        });
    }

    // «Comprar todo»: un solo POST con todos los productos de la lista activa
    buyAll() {
      var button = this.buyAllButton;
      if (!button || button.getAttribute('aria-busy') === 'true') return;

      var state = window.SifrahWishlist.getState();
      var active = findList(state, state.active) || state.lists[0];
      var lines = [];
      var seen = {};
      var skipped = 0;

      active.items.forEach(function (item) {
        var id = parseInt(item.variantId, 10);
        if (!id) {
          skipped++;
          return;
        }
        if (seen[id]) return;
        seen[id] = true;
        lines.push({ id: id, quantity: 1 });
      });

      this.setStatus('');

      if (!lines.length) {
        this.setStatus('No hay productos disponibles para agregar en esta lista.');
        return;
      }

      var label = button.textContent;
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      button.classList.add('is-loading');
      button.textContent = 'Agregando…';

      var finish = function () {
        button.removeAttribute('aria-busy');
        button.disabled = false;
        button.classList.remove('is-loading');
        button.textContent = label;
      };

      addToCart(lines)
        .then(() => {
          finish();
          return refreshCart().then(() => {
            if (skipped) {
              this.setStatus(
                '',
                escapeHtml(
                  'Agregamos ' +
                    plural(lines.length, 'producto', 'productos') +
                    '. ' +
                    plural(skipped, 'producto no se pudo agregar', 'productos no se pudieron agregar') +
                    (skipped === 1 ? ' porque no tiene' : ' porque no tienen') +
                    ' variante disponible.'
                ) + ' <button type="button" class="wishlist-link" data-wishlist-open-cart>Ver carrito</button>'
              );
              return;
            }
            this.close();
            openThemeCart();
          });
        })
        .catch((error) => {
          finish();
          this.setStatus(
            (error && error.message ? error.message : 'No pudimos agregar los productos.') +
              ' Prueba agregándolos uno por uno.'
          );
        });
    }

    open() {
      if (this.isOpen) return;

      this.isOpen = true;
      this.render();
      document.body.addEventListener('click', this.onBodyClick);
      document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true }));
      document.dispatchEvent(
        new CustomEvent('theme:wishlist-drawer:opened', {
          detail: { target: this },
          bubbles: true,
        })
      );

      this.classList.add('is-open');
      this.syncToggleState(true);

      var closeButton = this.querySelector('[data-wishlist-drawer-close]');
      if (closeButton && typeof closeButton.focus === 'function') {
        closeButton.focus({ preventScroll: true });
      }
    }

    close() {
      if (!this.classList.contains('is-open')) return;

      this.isOpen = false;
      this.mode = null;
      this.classList.add('is-closing');
      this.classList.remove('is-open');
      this.syncToggleState(false);

      document.body.removeEventListener('click', this.onBodyClick);
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('theme:wishlist-drawer:closed', { bubbles: true }));

      window.setTimeout(() => {
        this.classList.remove('is-closing');
      }, 600);
    }

    syncToggleState(isExpanded) {
      document.querySelectorAll('[data-wishlist-toggle]').forEach((toggle) => {
        toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      });
    }

    toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }
  }

  customElements.define('wishlist-drawer', WishlistDrawer);
})();
